export const LINK_PAGAMENTO_TYPE_ID = 23;
